import { useContext, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import { Button, CardActions, CardContent, Modal, Snackbar, TextField } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import img from "../../Assets/Images/VULPES LOGO V1 SUPORTE HUGE .png";
// import Layout from "../../Styles/layout/index";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";

import { get_login, post_login } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { func_print } from "../../Func_genericas/func_print";
import LoadingVulpes from "../../Styles/Loader/loading";
import { cores } from "../../Func_genericas/valores_estaticos";
import { aviso_sem_info } from "../../Func_genericas/aviso_sem_info";
import { ITicketSuporte } from "../../Interfaces/suporte/suporte";
import { date_in_string_to_format_layout } from "../../Func_genericas/date_in_string_to_format_layout";
import { split_email_to_fit_in_small_boxes_layout } from "../../Func_genericas/split_email_to_fit_in_small_boxes_layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh'

    },

    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },

    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(3),
        width: theme.spacing(16),
        height: theme.spacing(16),
        minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "black",
    },
  })
);

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          // input label when focused
          "& label.Mui-focused": {
            color: "#c94f1e",
            // focused color for input with variant='standard'
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c94f1e",
            },
            // focused color for input with variant='filled'
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c94f1e",
            },
          },
          // focused color for input with variant='outlined'
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: "#c94f1e",
            },
          },
        },
      },
    },
  },
});

export default function TecnicoSuporte() {

  const classes = useStyles();

  const auth = useContext(AuthContext);


  const [emailvar, setEmailvar] = useState("");
  const [descriptionvar, setDescriptionvar] = useState("");
  // const [error, setError]=useState(false);
  const [msgError, setMsgError] = useState("");

  const [iserror, setiserror] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorDesc, setErrorDesc] = useState(false);
  const [errorDescMsg, seterrorDescMsg] = useState("");

  const [isloading, setIsLoading] = useState(false);
  const [open_modal_visualizar_lista_tickets, set_open_modal_visualizar_lista_tickets] = useState(false);

  const [tickets_lista, set_tickets_lista] = useState<ITicketSuporte[]>()



  function isValidEmail(email: any) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleClick = () => {
    if (!isValidEmail(emailvar)) {
      setError(true);
      setMsgError("Email inválido");
    } else if (descriptionvar === "") {
      setError(false);
      setMsgError("");
      setErrorDesc(true);
      seterrorDescMsg("O campo 'descrição' não pode estar vazio");
    } else {
      setErrorDesc(false);
      seterrorDescMsg("");
      setError(false);
      setMsgError("");
      submitTicket();
    }

  };

  const submitTicket = async () => {
    try {
      setIsLoading(true)
      const response = await post_login(auth.token.cookie_token, "/create_suporte",
        {
          payload: {
            id_ticket: 0,
            email_contacto: emailvar,
            mensagem: descriptionvar,
            estado: "",
            id_org: auth.user?.id_org,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        }
      );


      if (response.status !== 201) {
        setSuccess(false);
        setiserror(true);
      } else {
        setSuccess(true);
        setiserror(false);
        setEmailvar("");
        setDescriptionvar("");
      }
      setIsLoading(false)

    } catch (error) {
      setSuccess(false);
      setiserror(true);
      setIsLoading(false);
      func_print('submitTicket', error, true)
    }
  };


  const handle_open_list_tickets = async () => {
    try {
      setIsLoading(true)


      let res = await get_login(auth.token.cookie_token,
        `/get_suportes_by_org/${auth.user?.id_org}`
      );

      if (res.status === 200) {
        if (res.data.result.length !== 0) {
          set_tickets_lista(res.data.result);
          setSuccess(true);
          setiserror(false);
          set_open_modal_visualizar_lista_tickets(true)
        }
      } else {
        setSuccess(false);
        setiserror(true);
      }
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      func_print('handle_open_list_tickets', error, true)
    }
  }



  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        {/* <Layout title="Suporte" /> */}
        <HomeViewTecnico title=" Suporte" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          {isloading ? (
            <LoadingVulpes />
          ) : (
            <>
              <Snackbar
                open={iserror}
                autoHideDuration={2000}
                onClose={() => setiserror(false)}
              >
                <Alert
                  onClose={() => setiserror(false)}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  Erro ao realizar a sua operação
                </Alert>
              </Snackbar>
              <Snackbar
                open={success}
                autoHideDuration={2000}
                onClose={() => setSuccess(false)}
              >
                <Alert
                  onClose={() => setSuccess(false)}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  Operação realizada com sucesso
                </Alert>
              </Snackbar>
              <Modal
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                open={open_modal_visualizar_lista_tickets}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  backgroundColor: 'white',
                  width: '50%',
                  height: 600,
                  flexDirection: 'column',
                  borderRadius: 5,
                }}>
                  <div style={{
                    width: '100%',
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}>
                    <Button
                      sx={{ color: "#AAAAAA" }}
                      size="large"
                      onClick={() => {
                        set_open_modal_visualizar_lista_tickets(false)
                      }}
                    >
                      <CloseIcon />
                    </Button>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 20,
                    overflowY: 'scroll',
                    scrollbarWidth: 'thin',
                    width: '100%',
                    minHeight: 400,
                  }}>

                    <div style={{
                      margin: 3,
                      borderRadius: 3,
                      display: 'flex',
                      flexDirection: 'row',
                      backgroundColor: cores.cor1,
                      justifyContent: 'center',
                      height: 70,

                    }}>
                      <div style={{
                        display: 'flex',
                        flex: 0.25,
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        borderWidth: 1,
                        borderColor: 'white',
                        borderRightStyle: 'groove',
                        width: '100%',
                        height: '100%',
                        fontWeight: 'bold',

                      }}>
                        ID ticket
                      </div>
                      <div style={{
                        display: 'flex',
                        flex: 0.25,
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        color: 'white',
                        borderWidth: 1,
                        borderColor: 'white',
                        borderRightStyle: 'groove',
                        width: '100%',
                        height: '100%',
                        fontWeight: 'bold',

                      }}>
                        Data do registo
                      </div>
                      <div style={{
                        display: 'flex',
                        flex: 0.25,
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        color: 'white',
                        borderWidth: 1,
                        borderColor: 'white',
                        borderRightStyle: 'groove',
                        width: '100%',
                        height: '100%',
                        fontWeight: 'bold',

                      }}>
                        Email de contacto
                      </div>
                      <div style={{
                        display: 'flex',
                        flex: 0.25,
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        width: '100%',
                        height: '100%',
                        fontWeight: 'bold',

                      }}>
                        Estado
                      </div>
                    </div>
                    {
                      tickets_lista?.length === 0 ?
                        aviso_sem_info()
                        :
                        tickets_lista?.map((el, key) => {

                          return (
                            <div key={key} style={{
                              margin: 3,
                              borderRadius: 3,
                              display: 'flex',
                              flexDirection: 'row',
                              backgroundColor: cores.cor2,
                              // alignItems:'center',
                              justifyContent: 'center',
                              height: 70,

                            }}>
                              <div style={{
                                display: 'flex',
                                flex: 0.25,
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                borderWidth: 1,
                                borderColor: 'white',
                                borderRightStyle: 'groove',
                                width: '100%',
                                height: '100%',

                              }}>
                                {el.id_ticket}
                              </div>
                              <div style={{
                                display: 'flex',
                                flex: 0.25,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                color: 'white',
                                borderWidth: 1,
                                borderColor: 'white',
                                borderRightStyle: 'groove',
                                width: '100%',
                                height: '100%',

                              }}>
                                {date_in_string_to_format_layout(el.create_date)}

                              </div>
                              <div style={{
                                display: 'flex',
                                flex: 0.25,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                color: 'white',
                                borderWidth: 1,
                                borderColor: 'white',
                                borderRightStyle: 'groove',
                                width: '100%',
                                height: '100%',

                              }}>

                                {split_email_to_fit_in_small_boxes_layout(el.email_contacto)}
                              </div>
                              <div style={{
                                display: 'flex',
                                flex: 0.25,
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                width: '100%',
                                height: '100%',

                              }}>
                                {el.estado}

                              </div>
                            </div>
                          )


                        })
                    }
                  </div>

                </div>



              </Modal>
              <div
                style={{
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: "center",
                  justifyContent: "center",

                }}
              >
                <Card
                  sx={{
                    display: "flex",
                    width: "50%",
                  }}
                >


                  <CardContent>

                    <div style={{

                      paddingLeft: 10,
                      display: 'flex',
                      flexDirection: 'row',

                    }}>
                      <div style={{
                        display: "flex",
                        flexDirection: 'column',
                        justifyContent: 'center',

                      }}>

                        <Typography
                          component="div"
                          variant="h3"
                          fontFamily="candara"
                          color="#7e2706"
                        >
                          Suporte

                        </Typography>

                        <Typography
                          variant="subtitle1"
                          color="text.secondary"
                          component="div"
                          fontFamily="candara"
                        >
                          Linha de apoio
                        </Typography>
                      </div>

                      <CardMedia
                        component="img"
                        sx={{
                          width: "15%",
                          height: "15%",
                          // margin: "auto",
                          // marginTop: "auto",
                          // marginBottom: "auto",
                        }}
                        image={img}
                        alt="Caderno de Campo"
                      />
                    </div>

                    <div style={{
                      paddingLeft: 10,
                      paddingRight: 10,

                    }}>
                      <TextField
                        error={error}
                        helperText={msgError}
                        fullWidth
                        id="username"
                        label={
                          <Typography fontFamily="candara">
                            Email para contacto
                          </Typography>
                        }
                        placeholder="Email "
                        margin="normal"
                        sx={{ width: "100%" }}
                        value={emailvar}
                        onChange={(e) => setEmailvar(e.target.value)}
                      />

                      <TextField
                        error={errorDesc}
                        helperText={errorDescMsg}
                        id="outlined-multiline-static"
                        label={
                          <Typography fontFamily="candara">
                            Descrição
                          </Typography>
                        }
                        placeholder="Descrição"
                        multiline
                        sx={{ width: "100%" }}
                        rows={5}
                        value={descriptionvar}
                        onChange={(e) => setDescriptionvar(e.target.value)}
                      />
                    </div>
                    <CardActions
                      style={{
                        display: "flex",
                        alignItems: "right",
                        justifyContent: "right",
                        marginRight: 10,
                      }}
                    >
                      <Button
                        variant="contained"
                        size="medium"
                        sx={{
                          backgroundColor: cores.cor1,
                          fontFamily: "candara",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#f7a837",
                          },
                        }}
                        onClick={() => handle_open_list_tickets()}
                      >
                        Ver lista de tickets
                      </Button>
                      <Button
                        variant="contained"
                        size="medium"
                        sx={{
                          backgroundColor: "#ffffff",
                          fontFamily: "candara",
                          color: "#000000",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#f7a837",
                          },
                        }}
                        onClick={() => handleClick()}
                      >
                        Enviar
                      </Button>
                    </CardActions>
                  </CardContent>

                  <br />
                </Card>
              </div>
            </>)}
        </main>
      </div>
    </ThemeProvider>
  );
}
